import { useEffect, useState } from "react";

export const BREAKPOINT_TABLET = 960;
export const BREAKPOINT_MOBILE = 600;
export const BREAKPOINT_SMALL = 380;

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const handler = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };

    mql.addEventListener("change", handler);
    return () => {
      mql.removeEventListener("change", handler);
    };
  }, [query]);

  return matches;
}
